import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Input from '../ui/Input';

const CustomerDiscoveryNav = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [activeFilters, setActiveFilters] = useState([]);

  // Hidden filters: wedding, portrait, event, commercial
  const filters = [
    // All filters hidden per user request
  ];

  const handleFilterToggle = (filterId) => {
    setActiveFilters((prev) =>
      prev?.includes(filterId)
        ? prev?.filter((id) => id !== filterId)
        : [...prev, filterId]
    );
  };

  const isFilterActive = (filterId) => activeFilters?.includes(filterId);

  const handleSearch = (e) => {
    e?.preventDefault();
    if (searchQuery?.trim()) {
      navigate(`/browse-photographers?search=${encodeURIComponent(searchQuery)}`);
    }
  };

  return (
    <div className="customer-discovery-nav">
      <form onSubmit={handleSearch} className="mb-4">
        <Input
          type="search"
          placeholder="ابحث عن مصور..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e?.target?.value)}
          className="w-full"
        />
      </form>
      <div className="customer-discovery-filters">
        {filters?.map((filter) => (
          <div
            key={filter?.id}
            onClick={() => handleFilterToggle(filter?.id)}
            className={`customer-discovery-filter ${
              isFilterActive(filter?.id) ? 'customer-discovery-filter-active' : ''
            }`}
          >
            <Icon name={filter?.icon} size={18} />
            <span>{filter?.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerDiscoveryNav;